import React, { Fragment } from 'react';
import { Hero } from '../../components/Hero';
import {
  H2,
  StyledPageContainer,
  StyledPageContent,
  StyledPageWrapper,
} from '../../components/styles';

interface AboutProps {}

export const About: React.FC<AboutProps> = ({}) => {
  return (
    <Fragment>
      <StyledPageWrapper>
        <Hero>
          <StyledPageContainer>
            <H2>O projektu</H2>
            <p>
              Web <strong>hlasování.Brno</strong> umožňuje snadno vyhledávat
              výsledky hlasování ze schůzí brněnského městského zastupitelstva.
              Lze využít jak vyhledávací pole s možností vyhledávat pomocí
              klíčových slov, tak výsledky procházet v seznamu chronologicky.
            </p>
            <p>
              Podrobnosti o hlasování jsou zobrazené v přehledné vizualizaci
              spolu s dalšími užitečnými údaji. Důležité informace o chodu a
              řízení města Brna jsou tak občanům zpřístupněné dostupnou a
              srozumitelnou formou.
            </p>
          </StyledPageContainer>
        </Hero>
        <StyledPageContainer>
          <StyledPageContent>
            <H2>Zdroj dat</H2>
            <p>
              Zdrojem dat o hlasováních zastupitelstva je brněnský katalog
              otevřených dat{' '}
              <a href="https://data.brno.cz/" target="_blank">
                data.Brno
              </a>
              , konkrétně dataset{' '}
              <a
                href="https://data.brno.cz/documents/mestobrno::hlasov%C3%A1n%C3%AD-zastupitelstva-city-council-voting-data/about"
                target="_blank"
              >
                Hlasování zastupitelstva
              </a>
              . Tento dataset spravuje a pravidelně aktualizuje přímo Magistrát
              města Brna. Web{' '}
              <span style={{ fontStyle: 'italic' }}>hlasování.Brno</span>{' '}
              uvedená data pouze přebírá, agreguje a zobrazuje v uživatelsky
              přívětivé podobě.
            </p>
            <H2>Vznik projektu</H2>
            <p>
              Prototyp tohoto webu vznikl jako soutěžní projekt v rámci
              24hodinového brněnského datového hackatonu{' '}
              <a
                href="https://www.linkedin.com/posts/madvorak_hackujbrno-ai-pivnaedci-activity-6919216369322360832-F226"
                target="_blank"
              >
                #HackujBrno 2022
              </a>
              , pořádaného městem Brnem ve spolupráci s Czechitas a Brno.AI.
            </p>
            <p>
              Projekt se v rámci soutěže umístil na druhém místě z celkových 12
              projektů.
            </p>
            <p>
              Následně byl tento prototyp rozšířen, dokončen a připraven pro
              použití pro širokou veřejnost.
            </p>
            <H2>Autoři</H2>
            <p>
              Na implementaci webu <strong>hlasování.Brno</strong> se podíleli:
            </p>
            <ul>
              <li>
                <strong>Ondřej Zelený</strong>
              </li>
              <li>
                <strong>Jan Pražák</strong>
              </li>
              <li>
                <strong>Jan Konstant</strong>
              </li>
              <li>
                <strong>Radim Blaha</strong>
              </li>
            </ul>
            <p>alias Tým Pivníci.</p>
          </StyledPageContent>
        </StyledPageContainer>
      </StyledPageWrapper>
    </Fragment>
  );
};
